export const UNIT_MS: Record<string, number> = {
  d: 86_400_000,
  h: 3_600_000,
  m: 60_000,
  s: 1_000
};

function tryParse(value: string | undefined): number | undefined {
  if (!value) return undefined;
  const match = value.trim().match(/^(\d+)(d|h|m|s)$/);
  if (!match) return undefined;
  return parseInt(match[1]!, 10) * (UNIT_MS[match[2]!] ?? 1);
}

/**
 * Parse a human-readable duration string into milliseconds.
 * Supported units: d (days), h (hours), m (minutes), s (seconds).
 * Falls back to `defaultValue` (same format) when `value` is missing or unrecognised.
 *
 * @example
 * parseDurationMs('24h', '1h')  // 86400000
 * parseDurationMs(undefined, '24h')  // 86400000
 * parseDurationMs('bad', '30m')  // 1800000
 */
export function parseDurationMs(value: string | undefined, defaultValue: string): number {
  return tryParse(value) ?? tryParse(defaultValue) ?? 0;
}

/** Formats a whole number of seconds as `m:ss`, e.g. 47 -> "0:47", 90 -> "1:30". */
export function formatCountdown(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  return `${minutes}:${String(remainder).padStart(2, '0')}`;
}

/** Rounds a duration in seconds to whole minutes, e.g. 300 -> "5". */
export function formatWholeMinutes(seconds: number): string {
  return String(Math.round(seconds / 60));
}
